import React from "react";
import {Alert, Col} from "reactstrap";
import ResponsiveImageSet from "../../../components/UI/ResponsiveImageSet/ResponsiveImageSet";
import NumbersAndBrandXs from "../../../assets/images/zahlen-und-marken-xs-rgb.webp"
import NumbersAndBrandLg from "../../../assets/images/zahlen-und-marken-lg-rgb.webp"

const NumbersAndBrand = (props) =>{
    return (
        // dismissNumbersAndBrand is passed as a prop to NumbersAndBrand
        <Col className="col-sm-12 col-lg-4 order-lg-3">
            <Alert toggle={props.dismissNumbersAndBrand} color="dark" className={"p-0 overflow-hidden"}>
                <ResponsiveImageSet imageXs={NumbersAndBrandXs} imageLg={NumbersAndBrandLg} altText="Zahlen und Marke"/>
            </Alert>
        </Col>
    );
}

export default NumbersAndBrand;